<template>
    <div ref="excel_meeting_detail" style="height: 0;width: 100%;overflow: hidden;">
        <table class="table">
            <tbody>
            <tr>
                <td>ID</td>
                <td colspan="4"> {{ meeting.id }}</td>
            </tr>
            <tr>
                <td>会议号</td>
                <td colspan="4"> {{ meeting.meeting_id ? meeting.meeting_id : '待创建' }}</td>
            </tr>
            <tr>
                <td>会议名称</td>
                <td colspan="4"> {{ meeting.topic }}</td>
            </tr>
            <tr>
                <td>会议时间</td>
                <td> {{ meeting.meeting_date }}</td>
                <td>{{ meeting.meeting_time }}</td>
                <td>({{ meeting.duration }})</td>
            </tr>
            <tr>
                <td>会议密码</td>
                <td colspan="4"> {{ meeting.password ? meeting.password : '无' }}</td>
            </tr>
            <tr>
                <td>会议主持人</td>
                <td colspan="4"> {{ meeting.host_name }}({{ meeting.host_id }})</td>
            </tr>
            <tr>
                <td>被邀请参会者</td>
                <td colspan="4">
                        <span v-for="item in emails" :key="item.emails">
                                    <i class="fa fa-user-circle-o"></i> {{ item.name }}
                                    {{ item.over ? ('&lt;' + item.email + '&gt;') : '' }}
                        </span>
                </td>
            </tr>
            <tr>
                <td>会议选项</td>
                <td colspan="4">
                    <span v-if="meeting.waiting_room === '1'"> 等候室 </span>
                    <span v-if="meeting.auto_record === '1'"> 自动录制 </span>
                    <span v-if="meeting.option_jbh === '1'"> 提前参会 </span>
                    <span v-if="meeting.option_live === '1'"> 启动直播 </span>
                    <span v-if="meeting.option_interpreter === '1'"> 启用同传 </span>
                </td>
            </tr>
            <tr>
                <td>会议介绍</td>
                <td colspan="4"><span v-html="meeting.description"></span></td>
            </tr>
            <tr>
                <td>参与人数</td>
                <td colspan="4"> {{ meeting.participant_count || '' }}</td>
            </tr>
            <tr>
                <td>实际参与</td>
                <td> 用户id</td>
                <td> 姓名</td>
                <td> 邮箱</td>
                <td> 参与时间</td>
                <td> 参会次数</td>
                <td> 时长(分钟)</td>
                <td> 百分比</td>
            </tr>
            <tr v-for="(item,index) in meeting.participants" :key="index">
                <td></td>
                <td>{{ item.userid }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.user_email }}</td>
                <td>{{
                        item.last_join_at ? (item.first_join_at.slice(0, 16) + ' ~ '
                            + item.last_join_at.slice(0, 11)
                            + item.last_join_at.slice(item.last_join_at.length > 23 ? -8 : -5, 5)) : item.first_join_at
                    }}
                </td>
                <td>{{ item.count }}</td>
                <td>{{ item.minutes }}</td>
                <td>{{ item.score }}</td>
            </tr>
            <tr>
                <td colspan="7">&nbsp;</td>
            </tr>
            <template v-if="meeting.label_attendee">
                <tr>
                    <td colspan="7">&nbsp;</td>
                </tr>
                <tr>
                    <td colspan="7">出勤汇总:</td>
                </tr>
                <template v-for="(label,key) in meeting.label_attendee">
                    <tr :key="key">
                        <td>{{ label.label }}</td>
                        <td>{{ label.attendees }}/{{ label.user_number }}</td>
                        <td>登录ID</td>
                        <td>姓名</td>
                        <td>部门</td>
                        <td>出勤</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-for="(item,index) in label.data" :key="index">
                        <td></td>
                        <td></td>
                        <td>{{ item.userid }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.department }}</td>
                        <td>{{ item.status }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr :key="'e'+key">
                        <td colspan="7">&nbsp;</td>
                    </tr>
                </template>
                <tr>
                    <td colspan="7">&nbsp;</td>
                </tr>
            </template>
            <tr v-for="(x,i) in meeting.polls" :key="i">
                <td v-for="(y,ii) in x" :key="ii">
                    {{ y }}
                </td>
                <!-- 继续补充td 直到满8个位置 -->
                <td v-for="j in 8-x.length" :key="j"></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
    name: "meeting-detail-report-table",
    props: {
        meeting: {
            type: Object,
            default: () => {
                return {}
            }
        },
        emails: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    methods: {
        // 导出表格
        exportExcel() {
            /* generate workbook object from table */
            let wb = XLSX.utils.table_to_book(this.$refs['excel_meeting_detail'], {raw: true});
            const id = this.meeting.id;
            /* get binary string as output */
            let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            let now = new Date().Format('yyyy-MM-dd');
            try {
                FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `会议详情-${id}-${now}.xlsx`)
            } catch (e) {
                console.log(e, wbout)
            }
            return wbout
        },
    }
}
</script>

<style scoped>

</style>